import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=362c3b91&scoped=true&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c3b91",
  null
  
)

export default component.exports